import { NeoModel } from "@singularsystems/neo-core";
import BaseStaticEventCommand from "./BaseStaticEventCommand";

@NeoModel
export default class UpdateStaticEventCommand extends BaseStaticEventCommand {
    public staticEventID: number = 0;
}